import { Store } from 'redux';
import { AlightCustomSettingsType } from '../../settings/alight-custom-settings';
import { Input } from '@alme/ui-web/types/input';
import { AlightStateType } from '../../types/alight-state';

export default class EmbeddInputHandler {
    _settings: AlightCustomSettingsType;
    _store: Store<AlightStateType> | undefined;

    constructor(settings: AlightCustomSettingsType) {
        this._settings = settings;
    }

    getRequestProcessor() {
        return this;
    }

    initialize(store: Store<AlightStateType>) {
        this._store = store;
    }

    getPromise(){
        return Promise.resolve();
    }

    process(input: Input){
        let inputParameters: any = {};
        if (input.parameters) {
            inputParameters = input.parameters;
        }
        if(this._store?.getState()?.Window.IsEmbedded)
        {
            if(input.origin === this._settings.originConstants.click && (input.messageType === this._settings.messageConstants.requestUnitRequest || input.messageType === this._settings.messageConstants.converseRequest))
            {
                if(window.fetchSearchResults)
                {
                  window.fetchSearchResults(input.displayText);
                }
            }
        }
        return Object.assign({}, input, { parameters: inputParameters });
    }
}



// WEBPACK FOOTER //
// ./modules/custom-embed-input-handler/embed-input-handler.ts